import { render, staticRenderFns } from "./ClubPricePrettyDetails.vue?vue&type=template&id=81a49710&scoped=true&"
import script from "./ClubPricePrettyDetails.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClubPricePrettyDetails.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ClubPricePrettyDetails.vue?vue&type=style&index=0&id=81a49710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a49710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81a49710')) {
      api.createRecord('81a49710', component.options)
    } else {
      api.reload('81a49710', component.options)
    }
    module.hot.accept("./ClubPricePrettyDetails.vue?vue&type=template&id=81a49710&scoped=true&", function () {
      api.rerender('81a49710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/PaymentClub/components/PriceDetails/components/ClubPricePrettyDetails.vue"
export default component.exports